/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Document_Access_GrantedInputs */

const en_document_access_granted = /** @type {(inputs: Document_Access_GrantedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Access Granted`)
};

const id_document_access_granted = /** @type {(inputs: Document_Access_GrantedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Akses Diberikan`)
};

/** @type {(inputs: Document_Access_GrantedInputs) => LocalizedString} */
const es_document_access_granted = en_document_access_granted;

/** @type {(inputs: Document_Access_GrantedInputs) => LocalizedString} */
const fr_document_access_granted = en_document_access_granted;

/** @type {(inputs: Document_Access_GrantedInputs) => LocalizedString} */
const de_document_access_granted = en_document_access_granted;

/** @type {(inputs: Document_Access_GrantedInputs) => LocalizedString} */
const ja_document_access_granted = en_document_access_granted;

/** @type {(inputs: Document_Access_GrantedInputs) => LocalizedString} */
const zh_document_access_granted = en_document_access_granted;

/** @type {(inputs: Document_Access_GrantedInputs) => LocalizedString} */
const ar_document_access_granted = en_document_access_granted;

/** @type {(inputs: Document_Access_GrantedInputs) => LocalizedString} */
const it_document_access_granted = en_document_access_granted;

/** @type {(inputs: Document_Access_GrantedInputs) => LocalizedString} */
const ru_document_access_granted = en_document_access_granted;

/** @type {(inputs: Document_Access_GrantedInputs) => LocalizedString} */
const pt_document_access_granted = en_document_access_granted;

/** @type {(inputs: Document_Access_GrantedInputs) => LocalizedString} */
const ko_document_access_granted = en_document_access_granted;

/**
* | output |
* | --- |
* | "Access Granted" |
*
* @param {Document_Access_GrantedInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const document_access_granted = /** @type {((inputs?: Document_Access_GrantedInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Document_Access_GrantedInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_document_access_granted(inputs)
	if (locale === "es") return es_document_access_granted(inputs)
	if (locale === "fr") return fr_document_access_granted(inputs)
	if (locale === "de") return de_document_access_granted(inputs)
	if (locale === "ja") return ja_document_access_granted(inputs)
	if (locale === "zh") return zh_document_access_granted(inputs)
	if (locale === "ar") return ar_document_access_granted(inputs)
	if (locale === "id") return id_document_access_granted(inputs)
	if (locale === "it") return it_document_access_granted(inputs)
	if (locale === "ru") return ru_document_access_granted(inputs)
	if (locale === "pt") return pt_document_access_granted(inputs)
	return ko_document_access_granted(inputs)
});